import { render, staticRenderFns } from "./CompanyName.vue?vue&type=template&id=629e2a7f&scoped=true&"
import script from "./CompanyName.vue?vue&type=script&lang=js&"
export * from "./CompanyName.vue?vue&type=script&lang=js&"
import style0 from "./CompanyName.vue?vue&type=style&index=0&id=629e2a7f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629e2a7f",
  null
  
)

export default component.exports